module.exports = __webpack_public_path__ + "static/media/how-can-you-help.0d18117f.jpg";